import React, { useEffect, useRef } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

/**
 * Line chart of search position over time for a single query.
 * `history` is an array of PositionCheck objects ordered ascending by checked_at.
 * Lower position is better, so the Y axis is reversed.
 */
const PositionHistoryChart = ({ history = [] }) => {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    const labels = history.map((h) =>
      new Date(h.checked_at).toLocaleDateString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    );
    // Not-found checks have null position; render them as gaps.
    const data = history.map((h) => (h.found ? h.position : null));

    if (chartRef.current) {
      chartRef.current.destroy();
    }

    chartRef.current = new ChartJS(canvasRef.current, {
      type: "line",
      data: {
        labels,
        datasets: [
          {
            label: "Позиция в поиске",
            data,
            borderColor: "#f14635",
            backgroundColor: "rgba(241, 70, 53, 0.15)",
            tension: 0.3,
            spanGaps: false,
            pointRadius: 4,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            reverse: true,
            title: { display: true, text: "Позиция (меньше — лучше)" },
            ticks: { precision: 0 },
          },
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx) =>
                ctx.parsed.y == null
                  ? "Не найдено"
                  : `Позиция: ${ctx.parsed.y}`,
            },
          },
        },
      },
    });

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, [history]);

  if (!history.length) {
    return (
      <div className="tw-py-8 tw-text-center tw-text-gray-400">
        Нет истории проверок. Запустите проверку позиций.
      </div>
    );
  }

  return (
    <div style={{ height: 320 }}>
      <canvas ref={canvasRef} />
    </div>
  );
};

export default PositionHistoryChart;
